<template>
  <v-form ref="form" v-model="valid">
    <v-card>
      <v-card-text>
        <v-file-input
          :label="$t(`${type}.auditPeriodFilesForm.label`)"
          :hint="$t(`${type}.auditPeriodFilesForm.hint`)"
          :rules="[(v) => v.length > 0 || $t('validation.required')]"
          persistent-hint
          v-model="files"
          small-chips
          multiple
        />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click="save" :loading="loading" :disabled="!valid">
          {{ $t(`${type}.auditPeriodFilesForm.save`) }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="saved" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.saved") }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import UserAttachFilesToAuditPeriodMutation from "@/gql/mutations/UserAttachFilesToAuditPeriodMutation.gql";
import AuditorAttachFilesToAuditPeriodMutation from "@/gql/mutations/AuditorAttachFilesToAuditPeriodMutation.gql";

export default {
  props: {
    type: {
      type: String,
      default: "user",
    },

    auditPeriod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      files: [],
      valid: false,
      loading: false,
      saved: false,
    };
  },

  computed: {
    mutation() {
      return this.type === "user" ? UserAttachFilesToAuditPeriodMutation : AuditorAttachFilesToAuditPeriodMutation;
    },
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      await this.$apollo.mutate({
        mutation: this.mutation,
        variables: {
          id: this.auditPeriod.id,
          files: this.files,
        },
      });

      this.$refs.form.reset();
      this.loading = false;
      this.saved = true;
    },
  },
};
</script>
